import React, { useState, useRef, useEffect } from "react";
import { MdWorkOutline, MdClose } from "react-icons/md";
import { SiBuymeacoffee } from "react-icons/si";

const FloatingButton = () => {
  const [isOpen, setIsOpen] = useState(false);
  const menuRef = useRef(null);

  useEffect(() => {
    const handleOutsideClick = (e) => {
      if (menuRef.current && !menuRef.current.contains(e.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener("mousedown", handleOutsideClick);
    return () => document.removeEventListener("mousedown", handleOutsideClick);
  }, []);

  return (
    <div className="fixed bottom-10 right-10 z-[100]" ref={menuRef}>
      {/* Popup Menu */}
      <div
        className={`absolute bottom-[70px] right-0 bg-white p-3 rounded-xl shadow-[0_3px_20px_rgb(0,0,0,0.15)] flex flex-col gap-2 min-w-[220px] border border-gray-100 mb-2 origin-bottom-right transition-all duration-300 ease-in-out ${
          isOpen
            ? "opacity-100 scale-100 translate-y-0 pointer-events-auto"
            : "opacity-0 scale-95 translate-y-4 pointer-events-none"
        }`}
      >
        <a
          href="https://buymeacoffee.com/reactbd"
          target="_blank"
          rel="noreferrer"
          className="flex items-center gap-3 px-4 py-3 bg-[#FFDD00] text-black rounded-lg hover:bg-[#ffea4d] transition-all font-titleFont font-medium text-sm shadow-sm"
        >
          <SiBuymeacoffee className="text-xl" />
          Buy Me a Coffee
        </a>

        <a
          href="https://buymeacoffee.com/reactbd/extras"
          target="_blank"
          rel="noreferrer"
          className="flex items-center gap-3 px-4 py-3 bg-primeColor text-white rounded-lg hover:bg-designColor hover:text-primeColor transition-all font-titleFont font-medium text-sm shadow-sm"
        >
          <MdWorkOutline className="text-xl" />
          Get Sourde Code
        </a>
      </div>

      {/* Toggle Button */}
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="w-14 h-14 rounded-full flex items-center justify-center shadow-lg hover:-translate-y-1 transition-all duration-300 group bg-[#FFDD00] text-black hover:bg-[#ffea4d]"
      >
        {isOpen ? (
          <MdClose className="text-2xl" />
        ) : (
          <SiBuymeacoffee className="text-2xl group-hover:animate-bounce" />
        )}
      </button>
    </div>
  );
};

export default FloatingButton;
